export default "__VITE_ASSET__cf8eEoTO__"